import { graphql } from ':src/graphql';

export const potentialChatParticipantsQuery = graphql(`
  query PotentialChatParticipantsQuery {
    potentialChatParticipants {
      result {
        id
        type
        fullName
        firstName
        lastName
        smallAvatar
      }
    }
  }
`);

export const chatTimelineQuery = graphql(`
  query ChatTimelineQuery($chatId: String!, $cursor: String) {
    chatTimeline(chatId: $chatId, cursor: $cursor) {
      nextCursor
      result {
        __typename
        ... on ChatMessage {
          id
          createdAt
          chatId
          senderActorId
          text
        }
        ... on ChatEvent {
          id
          createdAt
          chatId
          chatEventTypeId
          targets {
            id
            targetActorId
            chatEventChangeTypeId
            targetActor {
              id
              fullName
            }
          }
        }
      }
    }
  }
`);

export const chatQuery = graphql(`
  query ChatQuery($id: String!) {
    chat(id: $id) {
      id
      isActive
      participants {
        id
        type
        fullName
        firstName
        lastName
        smallAvatar
        deletedAt
        inactiveAt
      }
      activeNonViewerParticipants {
        id
        type
        fullName
        firstName
        lastName
        smallAvatar
        deletedAt
        inactiveAt
      }
    }
  }
`);

export const chatsQuery = graphql(`
  query ChatsQuery {
    chats {
      id
      latestChatMessage {
        id
        text
        createdAt
      }
      participants {
        id
        type
        fullName
        firstName
        lastName
        smallAvatar
        deletedAt
        inactiveAt
      }
      isActive
    }
  }
`);

export const chatsWithUnreadMessagesQuery = graphql(`
  query ChatsWithUnreadMessagesQuery {
    chatsWithUnreadMessages {
      id
    }
  }
`);

export const viewerActorQuery = graphql(`
  query ViewerActorQuery {
    viewerActor {
      id
    }
  }
`);
